/* © 2026 Maqam. All rights reserved · Riyadh, Kingdom of Saudi Arabia.
 * Proprietary — see /LICENSE · legal@maqam-ksa.com */
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
